'use client';

const testimonials = [
  {
    quote: "We're a big company doing great work — everyday there's something happening that more people need to hear about.",
    role: 'VP',
    company: 'High growth, institutional backed company',
  },
  {
    quote: "We often joke about the line that when you feel like you're sick of repeating yourself, you're just starting to say it enough. With Apprendo my team can search, pull and share internal examples of what matters without me having to repeat myself constantly.",
    role: 'CEO',
    company: 'SaaS company',
  },
  {
    quote: "My job is to go out every day and share the narrative of my industry so buyers, regulators and the public trust us. Apprendo makes this simple and repeatable.",
    role: 'President & CEO',
    company: 'Dual-use hardware company',
  },
  {
    quote: "I used to hire a production team to come into the office once a year and record videos of my executive team. It cost a fortune and our marketing team hated trying to constantly re-cut old material. Now, they constantly get clips from all of our team — turning our leaders into thought leaders — automatically.",
    role: 'Founder & CEO',
    company: 'Design-led engineering company',
  },
  {
    quote: "I used to constantly re-record demo content for prospects. With Apprendo, the first take always works and every demo I record adds to our library of material that we can pull from. Less looms and more time with leads — love it!",
    role: 'Sales Leader',
    company: 'Technology company',
  },
];

export default function CustomerStoriesSection() {
  return (
    <section className="py-20">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-13">
          <div className="landing-section-label">What leaders are saying</div>
          <h2 className="text-[38px] font-bold tracking-[-1.5px] mb-3.5 text-foreground">
            From executives to sales teams
          </h2>
          <p className="text-[17px] text-muted-foreground max-w-[540px] mx-auto">
            Conversations become their most valuable content.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.slice(0, 3).map((t) => (
            <div
              key={t.role}
              className="bg-card border border-border rounded-[16px] p-8 flex flex-col transition-all hover:-translate-y-1 hover:shadow-md"
            >
              <div className="text-[48px] text-[#EF4444] opacity-25 leading-none mb-1.5 font-serif">
                &ldquo;
              </div>
              <p className="text-[15px] leading-[1.7] text-foreground flex-1 mb-5">{t.quote}</p>
              <div>
                <div className="font-bold text-[14px] text-foreground">{t.role}</div>
                <div className="text-[12px] text-muted-foreground">{t.company}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6 max-w-[800px] mx-auto">
          {testimonials.slice(3).map((t) => (
            <div
              key={t.role}
              className="bg-card border border-border rounded-[16px] p-8 flex flex-col transition-all hover:-translate-y-1 hover:shadow-md"
            >
              <div className="text-[48px] text-[#EF4444] opacity-25 leading-none mb-1.5 font-serif">
                &ldquo;
              </div>
              <p className="text-[15px] leading-[1.7] text-foreground flex-1 mb-5">{t.quote}</p>
              <div>
                <div className="font-bold text-[14px] text-foreground">{t.role}</div>
                <div className="text-[12px] text-muted-foreground">{t.company}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
